/* Málaga: ficha de producto. Variantes, precio, galería y agregar a la bolsa sin recargar. */

(() => {
  const root = document.querySelector('[data-product]');
  if (!root) return;

  const variantsEl = root.querySelector('[data-variants]');
  const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  const form = root.querySelector('[data-product-form]');
  const idInput = root.querySelector('[data-variant-id]');
  const priceCurrent = root.querySelector('[data-price-current]');
  const priceWas = root.querySelector('[data-price-was]');
  const addBtn = root.querySelector('[data-add-to-cart]');
  const addLabel = root.querySelector('[data-add-label]');
  const feedback = root.querySelector('[data-add-feedback]');
  const options = [...root.querySelectorAll('[data-option-index]')];
  // Las tres salen del mismo lugar. Leer "add" del DOM era un bug: si se entraba con
  // ?variant= de una variante agotada, el botón arrancaba diciendo "Agotado" y esa
  // palabra quedaba capturada como el texto normal, así que al elegir un talle CON
  // stock el botón seguía diciendo AGOTADO aunque se pudiera comprar.
  const strings = {
    add: root.dataset.add || 'Agregar a la bolsa',
    soldOut: root.dataset.soldOut || 'Agotado',
    unavailable: root.dataset.unavailable || 'No disponible',
  };

  const money = (cents) => {
    // Gs. 289.000 (sin decimales, punto de miles)
    const n = Math.round(cents / 100);
    return 'Gs. ' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const selected = () =>
    options.map((fs) => {
      const checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });

  const findVariant = (opts) =>
    variants.find((v) => v.options.every((o, i) => o === opts[i]));

  // Marca como agotadas las opciones que, combinadas con lo demás elegido, no tienen stock
  const markAvailability = (opts) => {
    options.forEach((fs, i) => {
      fs.querySelectorAll('[data-option-input]').forEach((input) => {
        const probe = opts.slice();
        probe[i] = input.value;
        const v = findVariant(probe);
        const label = input.nextElementSibling;
        label.classList.toggle('is-unavailable', !v || !v.available);
      });
      const sel = fs.querySelector('[data-option-selected]');
      if (sel) sel.textContent = opts[i] || '';
    });
  };

  const update = () => {
    if (!options.length) return;
    const opts = selected();
    const v = findVariant(opts);
    markAvailability(opts);

    if (!v) {
      addBtn.disabled = true;
      addLabel.textContent = strings.unavailable;
      return;
    }
    idInput.value = v.id;
    priceCurrent.textContent = money(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      priceWas.textContent = money(v.compare_at_price);
      priceWas.hidden = false;
      priceCurrent.classList.add('price--sale');
    } else {
      priceWas.hidden = true;
      priceCurrent.classList.remove('price--sale');
    }
    addBtn.disabled = !v.available;
    addLabel.textContent = v.available ? strings.add : strings.soldOut;

    // URL compartible con la variante
    const url = new URL(location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState({}, '', url);

    // Foto de la variante
    if (v.featured_media && v.featured_media.id) {
      const media = root.querySelector(`[data-media-id="${v.featured_media.id}"]`);
      if (media) {
        const track = root.querySelector('[data-gallery-track]');
        if (window.matchMedia('(max-width: 1023px)').matches) {
          track.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
        } else {
          media.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }
  };

  options.forEach((fs) => fs.addEventListener('change', update));
  if (options.length) markAvailability(selected());

  // ---- Contador de galería (móvil) ----
  const track = root.querySelector('[data-gallery-track]');
  const indexEl = root.querySelector('[data-gallery-index]');
  if (track && indexEl) {
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth) + 1;
        indexEl.textContent = String(Math.max(1, i));
      });
    }, { passive: true });
  }

  // ---- Agregar a la bolsa ----
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.classList.add('is-loading');
      feedback.hidden = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'error');
        }
        const cart = await (await fetch('/cart.js')).json();
        // Contadores del header: el ícono (móvil) y el texto "Bolsa (N)" (desktop)
        document.dispatchEvent(new CustomEvent('malaga:cart', { detail: cart.item_count }));
        // Abre el carrito lateral. Si no está (por ejemplo sin JS del drawer), queda
        // el mensaje de abajo con el enlace a la bolsa.
        document.dispatchEvent(new CustomEvent('malaga:added'));
        feedback.replaceChildren();
        feedback.append(document.createTextNode(root.dataset.added || 'Agregado a la bolsa.'));
        const link = document.createElement('a');
        link.className = 'link';
        link.href = root.dataset.cartUrl || '/cart';
        link.textContent = root.dataset.viewCart || 'Ver bolsa';
        feedback.append(link);
        feedback.hidden = false;
      } catch (err) {
        feedback.textContent = err.message || 'No se pudo agregar. Probá de nuevo.';
        feedback.hidden = false;
      } finally {
        addBtn.classList.remove('is-loading');
      }
    });
  }

  // ---- Dialog guía de talles (si theme.js ya lo maneja, esto no duplica) ----
})();
